<template>
    <div>
        <h1 class="display-heading">{{pageTitle}}</h1>
        <form data-vv-scope="user-dependent" @submit.prevent="validateTierForm">
            <!-- <div v-if="!isNewUser" class="alert alert-success" role="alert">
                User with entered identity card number "{{ form.in }}" has an existing user account on {{ companyName }}.<br>
                Hence his/her personal details is not editable.
            </div> -->
            <div class="row">
                <div class="form-group col-md-6">
                    <label>Full Name</label>
                    <input type="text" placeholder="Full Name" name="fullName" v-model="form.fn"
                        data-vv-as="full name" data-vv-validate-on="change"
                        v-validate="'required'" :disabled="!isNewUser" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('user-dependent.fullName')
                    }">
                    <div v-show="validationErrors.has('user-dependent.fullName')"
                        class="invalid-feedback">
                        {{ validationErrors.first('user-dependent.fullName') }}
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label>Identity Type</label>
                    <select placeholder="Identity Type" name="identityType" v-model="form.it"
                        data-vv-as="identity type" data-vv-validate-on="change"
                        v-validate="identificationTypeValidation" :disabled="!isNewUser" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('user-dependent.identityType')
                    }">
                        <option v-for="(identificationType, index) in identificationTypes" :key="index"
                            :value="identificationType.value">
                            {{identificationType.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('user-dependent.identityType')" class="invalid-feedback">
                        {{ validationErrors.first('user-dependent.identityType') }}
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label>Identity Number</label>
                    <input type="text" :placeholder="form.it === 1 ? '######-##-####' : 'Identity Number'" name="identityNumber" v-model="form.in"
                        data-vv-as="identity number" data-vv-validate-on="change"
                        v-validate="'required'" v-mask="form.it === 1 ? '######-##-####' : null" :disabled="!isNewUser" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('user-dependent.identityNumber')
                    }">
                    <div v-show="validationErrors.has('user-dependent.identityNumber')"
                        class="invalid-feedback">
                        {{ validationErrors.first('user-dependent.identityNumber') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Birth date</label>
                    <input type="text" placeholder="DD/MM/YYYY" name="dob" v-model="form.dob" class="form-control" v-mask="'##/##/####'"  :disabled="!isNewUser">
                </div>
                <div class="form-group col-md-4">
                    <label>Email</label>
                    <input type="text" placeholder="Email" name="email" v-model="form.e"
                        data-vv-as="email" data-vv-validate-on="change"
                        v-validate="'required|email'" :disabled="form.iru" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('user-dependent.email')
                    }">
                    <div v-show="validationErrors.has('user-dependent.email')"
                        class="invalid-feedback">
                        {{ validationErrors.first('user-dependent.email') }}
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label>Phone Number</label>
                    <input type="text" placeholder="Phone Number" name="phoneNumber" v-model="form.pn" class="form-control" :disabled="!isNewUser">
                </div>
                <div class="form-group col-md-4">
                    <label>Relationship</label>
                    <select placeholder="Relationship" name="relationship" v-model="form.r"
                        data-vv-as="relationship" data-vv-validate-on="blur"
                        v-validate="'required'" :disabled="!isNewUser" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('user-dependent.relationship')
                    }">
                        <option :value="null" disabled hidden>Please Select...</option>
                        <!-- <option v-for="(relationshipType, index) in relationshipTypes.filter(function(element){ return element.value > 0; })" :key="index"
                            :value="relationshipType.text">
                            {{relationshipType.text}}
                        </option> -->
                        <option value='Spouse'>Spouse</option>
                        <option value='Dependent'>Dependent</option>
                        <option value='Parent'>Parent</option>
                        <option value='Sibling'>Sibling</option>
                        <option value='Others'>Others</option>
                    </select>
                    <div v-show="validationErrors.has('user-dependent.relationship')"
                        class="invalid-feedback">
                        {{ validationErrors.first('user-dependent.relationship') }}
                    </div>
                </div>
            </div>

            <p v-if="shouldShowSubmitMessage"
                :class="{
                    'text-danger': submitHasError
                }" v-html="submitMessage">
            </p>
            <div>
                <button v-if="!form.iru" type="button" class="btn btn-primary mr-2 mb-2" @click="saveChanges" :disabled="isSaving">
                    Save
                </button>
                <button v-if="!form.iru && !isNewUser" type="button" class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="sendInvitation">
                    Invite User
                </button>
                <button v-if="form.agr" type="button" class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="sendGuardianRequest" :disabled="disableGuardianRequest">
                    {{ guardianRequestText }}
                </button>
                <i v-show="form.agr && form.iaa" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" data-placement='right' :title="getAutoAuthRequestGuardianLabel()"></i>
                <i v-show="form.agr && !form.iaa" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" data-placement='right' :title="getManualRequestGuardianLabel()"></i>
                <div>
                    <router-link class="btn btn-secondary mr-2 mb-2" :to="{'name': 'family-list'}">Back to List</router-link>
                </div>
            </div>
        </form>

        <popup-modal ref="popupAlert" :hasCloseButton="false" :title="submitTitle">
            <template slot="content">
                <p v-html="submitMessage">
                    {{submitMessage}}
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="dismissSubmitMessage">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import identificationTypes from '@/config/identificationTypes';
import relationshipTypes from '@/config/relationshipTypes';
import {
    mask
} from 'vue-the-mask';
import popupModal from '@/components/popup-modal';
export default {
    'name': '',
    'components': {
        popupModal
    },
    'directives': {
        mask
    },
    'computed': {
        userDependentId () {
            return this.$route.name === 'family-detail' ? this.$route.params.id : null;
        },
        pageTitle () {
            if (this.$route.name === 'family-detail') {
                return 'View Family Member Details';
            } else if (this.$route.name === 'family-detail-add') {
                return 'Add New Family Member';
            } else {
                return 'Family Member Details';
            }
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        },
        guardianRequestText () {
            if (this.form.grs === 1) {
                return 'Guardian Permission Pending Approval';
            } else if (this.form.grs === 2) {
                return 'Guardian Permission Approved';
            }
            return 'Request Guardian Permission';
        },
        disableGuardianRequest () {
            return this.form.grs === 1 || this.form.grs === 2 || !this.form.iru;
        }
    },
    mounted () {
        if (this.userDependentId) {
            this.axios.get('UserDependent/GetUserDependentDetails', {
                'params': {
                    'userDependentId': this.userDependentId
                }
            }).then(({
                data
            }) => {
                let userDependentData = data.data;
                this.form.udi = userDependentData.udi;
                this.form.fn = userDependentData.fn;
                this.form.it = userDependentData.it;
                this.form.in = userDependentData.in;
                this.form.dob = convertDateToDDMMYYYY(userDependentData.dob);
                this.form.e = userDependentData.e;
                this.form.pn = userDependentData.pn;
                this.form.r = userDependentData.r;
                this.form.agr = userDependentData.agr;
                this.form.grs = userDependentData.grs;
                this.form.iru = userDependentData.iru;
                this.form.iaa = userDependentData.iaa;

                this.originalEmail = userDependentData.e;
            }).catch(() => {});
            this.isNewUser = false;
        } else {
            this.isNewUser = true;
        }
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="tooltip"]').hover(function () {
            $('.tooltip').css('top', parseInt($('.tooltip').css('left')) + 15 + 'px'); // offset the tooltip popup to the right
        });
    },
    data () {
        return {
            'searchIdentityType': 1,
            'searchIdentityNumber': '',
            'form': {
                'udi': null,
                'fn': null,
                'it': null,
                'in': null,
                'dob': null,
                'pn': null,
                'e': null,
                'r': null,
                'agr': null,
                'grs': null,
                'iru': null,
                'iaa': null
            },
            'originalEmail': '',
            'isSaving': false,
            'submitTitle': '',
            'submitMessage': '',
            'submitHasError': false,
            'isNewUser': false,
            identificationTypes,
            relationshipTypes
        };
    },
    'methods': {
        validateEmployeeTierForm () {
            return this.$validator.validateAll('user-dependent');
        },
        saveChanges () {
            this.validateEmployeeTierForm().then((isValid) => {
                if (isValid) {
                    let tempData = JSON.parse(JSON.stringify(this.form));
                    tempData.dob = tempData.dob ? convertDateToIso8601(tempData.dob) : null;

                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Saving dependent details...';
                    this.axios.post('UserDependent/SaveDependentDetails', tempData)
                        .then(({ data }) => {
                            this.originalEmail = this.form.e;
                            this.submitTitle = 'Success';
                            this.submitMessage = 'Dependent details saved!';
                        }).catch((error) => {
                            this.submitHasError = true;
                            this.submitTitle = 'Error';
                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage = 'Error saving dependent details... Please try again.';
                            }
                        }).finally(() => {
                            this.$refs.popupAlert.show();
                            this.isSaving = false;
                        });
                }
            });
        },
        dismissSubmitMessage () {
            this.$refs.popupAlert.hide();
            if (this.form.udi == null && !this.submitHasError) {
                this.$router.push(
                    {
                        'name': 'family-list'
                    });
            }
        },
        sendGuardianRequest () {
            if (this.originalEmail !== this.form.e) { // email has been updated
                this.submitTitle = 'Alert';
                this.submitMessage = 'Please save before sending request. ';
            } else {
                this.submitMessage = 'Sending request. Please wait...';
                // this.$refs.popupUpdateSuccessful.show();
                this.axios.get('UserDependent/RequestGuardianPermission', {
                    'params': {
                        'userDependentId': this.form.udi
                    }
                }).then(({ data }) => {
                    this.submitTitle = 'Success';
                    this.submitMessage = 'Request sent successfully!';
                    this.form.grs = 1;
                }).catch(() => {
                    this.submitHasError = true;
                    this.submitTitle = 'Error';
                    this.submitMessage = 'Error sending request. Please try again.';
                });
            }
            this.$refs.popupAlert.show();
        },
        sendInvitation () {
            this.validateEmployeeTierForm().then((isValid) => {
                if (isValid) {
                    if (this.originalEmail !== this.form.e) { // email has been updated
                        this.submitTitle = 'Alert';
                        this.submitMessage = 'Please save before sending invitation. ';
                    } else {
                        this.submitMessage = 'Sending invitation. Please wait...';
                        // this.$refs.popupUpdateSuccessful.show();
                        this.axios.get('UserDependent/SendInvitation', {
                            'params': {
                                'userDependentId': this.form.udi
                            }
                        }).then(({ data }) => {
                            this.submitTitle = 'Success';
                            this.submitMessage = 'Invitation sent successfully!';
                            this.form.grs = 1;
                        }).catch(() => {
                            this.submitHasError = true;
                            this.submitTitle = 'Error';
                            this.submitMessage = 'Error sending invitation. Please try again.';
                        });
                    }
                    this.$refs.popupAlert.show();
                }
            });
        },
        getAutoAuthRequestGuardianLabel () {
            return 'This function allows principal employee viewing information like medical records, expenses, etc of spouse and dependents.\n' +
            'Child(ren) below 18 years old\'s records are viewable by principal employee automatically.\n' +
            'Spouse\'s medical records can only be viewable by principal employee, only after spouse granting the permission.  Principal employee can seek spouse\'s permission by clicking "Guardian Permission" button.  An email will be issued when spouse either accept or decline this request.\n\n' +
            'Note : Guardian Permission button is only activated for principal employee, when the spouse and dependents ( above 18 years old ), are registered users with active accounts.';
        },
        getManualRequestGuardianLabel () {
            return 'This function allows principal family member viewing information like medical records, expenses, etc of spouse, dependents, siblings etc, provided they given permissions for such viewing.\n' +
                'Principal family member can seek permissions from other family members by clicking “Guardian Permission” button.\n' +
                'An email will be issued when invited family member either accept or decline the request of sharing later.\n' +
                'Note : Guardian Permission button is only activated for principal family member, when the invited family member has an active account and eKYC is completed within Health Savvy system.';
        }
    }
};

</script>

<style>

</style>
